import {configureStore} from '@reduxjs/toolkit';
import {authMiddleware} from 'mfe/host/app-auth-provider';

import {handleErrors, responseToPayload} from '@pb/middleware-api';


import api from '/src/middleware/api';
import {handleErrors as handle} from '/src/middleware/handle-errors';

import {rootReducer} from './reducer';

import type {ApiDispatchForToolkit} from '/src/openapi/doris-identity/types';
import type {Middleware} from '@reduxjs/toolkit';

export type PreloadedState = Partial<RootState>;

export type RootState = ReturnType<typeof rootReducer>;
export type AppState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const setupStore = (preloadedState?: PreloadedState) => configureStore({
    reducer: rootReducer,
    preloadedState,
    devTools: {name: 'UDCP CCDB'},
    middleware: getDefaultMiddleware => getDefaultMiddleware({
        serializableCheck: false,
    }).concat(
        authMiddleware,
        api as Middleware<ApiDispatchForToolkit, RootState>,
        handleErrors(handle) as unknown as Middleware,
        responseToPayload as Middleware,
    ),
});

export const store = setupStore();
